'use client';

import { c as _c } from "react/compiler-runtime";
import { useIsFetching } from '@tanstack/react-query';
import { TRPC_SETTINGS } from '~/constants/trpc';
import { api } from '~/libs/api';
import { tripRepriceKey } from '~/utils/tpv2/tripReprice';
export const useTripLiveCheck = (tripId, isPriceStale) => {
  const $ = _c(6);
  let t0;
  if ($[0] !== tripId) {
    t0 = tripRepriceKey(tripId);
    $[0] = tripId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isRepricing = useIsFetching(t0) > 0;
  let t1;
  if ($[2] !== tripId) {
    t1 = {
      tripId,
      replaceUnavailable: false
    };
    $[2] = tripId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = !!tripId && isPriceStale && !isRepricing;
  let t3;
  if ($[4] !== t2) {
    t3 = {
      ...TRPC_SETTINGS.QUERY_NO_REFETCH,
      enabled: t2,
      staleTime: Infinity,
      retry: false
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    isSuccess,
    isError
  } = api.trip.liveCheck.useQuery(t1, t3);
  return isPriceStale && !isSuccess && !isError;
};